import { render, staticRenderFns } from "./ParkingTable.vue?vue&type=template&id=66d32439&scoped=true"
import script from "./ParkingTable.vue?vue&type=script&lang=js"
export * from "./ParkingTable.vue?vue&type=script&lang=js"
import style0 from "./ParkingTable.vue?vue&type=style&index=0&id=66d32439&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d32439",
  null
  
)

export default component.exports